
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bewegen, Dehnen, Trainieren, Entspannen. So lautet die Therapie in Kürze. Wer
häufig unter Spannungskopfschmerzen leidet, sollte im Alltag regelmässig den
Kopf drehen, neigen und nach vorn beugen, die Schultern kreisen und die Haltung
immer wieder verändern. Auch Wärmeanwendungen oder Eiswürfel können guttun,
wobei Letztere nie direkt auf die Haut gelegt werden sollten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;